/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ locale: NonNullable<unknown> }} Blog_Ai_Translate_OfferInputs */

const cs_blog_ai_translate_offer = /** @type {(inputs: Blog_Ai_Translate_OfferInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hotovo v jazyce ${i?.locale}. Přeložit do dalších jazyků?`)
};

const en_blog_ai_translate_offer = /** @type {(inputs: Blog_Ai_Translate_OfferInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ready in ${i?.locale}. Translate to other languages?`)
};

/**
* | output |
* | --- |
* | "Ready in {locale}. Translate to other languages?" |
*
* @param {Blog_Ai_Translate_OfferInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const blog_ai_translate_offer = /** @type {((inputs: Blog_Ai_Translate_OfferInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Ai_Translate_OfferInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_blog_ai_translate_offer(inputs)
	return cs_blog_ai_translate_offer(inputs)
});